import React from 'react';
import classNames from 'classnames';
import Label from '../Label';
import baseStyles from '../Base.module.css';
import styles from './MapInput.module.css';
export default function MapInput(_a) {
    var _b, _c, _d;
    var label = _a.label, labelType = _a.labelType, required = _a.required, isValid = _a.isValid, validationMessage = _a.validationMessage, disabled = _a.disabled, content = _a.content, onMapVisible = _a.onMapVisible, onBlur = _a.onBlur;
    var handleOnBlur = function () {
        setTimeout(function () {
            onBlur ? onBlur() : undefined;
        }, 700);
    };
    return (React.createElement("div", { className: classNames(baseStyles.control, (_b = {},
            _b[baseStyles.controlTop] = labelType === 'top',
            _b)) },
        label && (React.createElement(Label, { label: label, labelType: labelType, required: required })),
        React.createElement("div", { className: classNames(baseStyles.inputContainer, (_c = {},
                _c[baseStyles.inputContainerTop] = labelType === 'top',
                _c)), style: { display: 'flex', flexWrap: 'wrap' } },
            React.createElement("section", { className: classNames(styles.controlInput, styles.input, (_d = {},
                    _d[styles.controlInputInvalid] = isValid === false,
                    _d[styles.inputDisabled] = disabled,
                    _d)), onClick: function () {
                    if (!disabled) {
                        onMapVisible();
                        handleOnBlur();
                    }
                } }, content &&
                content.map(function (line, index) { return (React.createElement("div", { key: line + index, className: styles.line },
                    index + 1,
                    ". ",
                    line)); })),
            isValid === false && (React.createElement("div", { className: baseStyles.validationMessage }, validationMessage)))));
}
